import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';  // adjust path as needed
import toast from 'react-hot-toast';
import {
    FiHome,
    FiShoppingBag,
    FiGrid,
    FiUser,
    FiLogIn,
    FiUserPlus,
    FiLogOut,
    FiShoppingCart,
    FiInfo,
    FiMail,
} from 'react-icons/fi';
import { useAuth } from '../../context/UserContext';
import { useCart } from '../../context/CartContext';
import utils from '../../utils';

function DrawerItem({ to, icon: Icon, children, onClick, badge }) {
    const location = useLocation();
    const isActive = location.pathname === to;

    return (
        <li>
            <Link
                to={to}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-md transition-all duration-200
      ${isActive
                        ? 'bg-secondary text-white font-medium shadow-sm'
                        : 'text-gray-300 hover:bg-gray-700 hover:text-white hover:pl-4'
                    }`}
                onClick={onClick}
            >
                <Icon
                    className={`text-xl flex-shrink-0 transition-colors
        ${isActive ? 'text-white' : 'text-gray-400 group-hover:text-white'}`}
                />
                <span className="transition-colors">{children}</span>
                {badge != null && (
                    <span className="ml-auto px-2 py-0.5 text-xs font-bold bg-primary text-white rounded-full whitespace-nowrap">
                        {badge}
                    </span>
                )}
            </Link>
        </li>
    );
}

export default function Drawer() {
    const { isAuth, logout  } = useAuth();
    const { numCartItems, resetCart } = useCart();
    const navigate = useNavigate();

    // Close drawer on link click
    const closeDrawer = () => {
        const drawerToggle = document.getElementById('nav-drawer');
        if (drawerToggle) {
            drawerToggle.checked = false;
        }
    };

    const handleLogout = () => {
        logout();
        resetCart();
        closeDrawer();
        navigate('/auth/login');
        setTimeout(() => {
            toast.success('Successfully logged out');
        }, 400);
    };

    return (
        <div className="drawer-side z-30">
            <label htmlFor="nav-drawer" className="drawer-overlay"></label>

            <ul
                className="menu bg-gray-800 min-h-full w-64 md:w-80 p-4 text-white space-y-1"
                onClick={(e) => {
                    if (e.target.closest('a')) {
                        closeDrawer();
                    }
                }}
            >
                <div className="flex justify-center mb-6 mt-10">
                    <Link
                        to="/"
                        className="text-xl font-black text-white hover:text-secondary"
                        onClick={closeDrawer}
                    >
                        {utils.siteName}
                    </Link>
                </div>
                <DrawerItem to="/" icon={FiHome}>Home</DrawerItem>
                <DrawerItem to="/products" icon={FiShoppingBag}>Products</DrawerItem>
                <DrawerItem to="/categories" icon={FiGrid}>Categories</DrawerItem>
                <DrawerItem to="/about" icon={FiInfo}>About</DrawerItem>
                <DrawerItem to="/contact" icon={FiMail}>Contact</DrawerItem>

                <li>
                    <div className="divider my-2 text-gray-500"></div>
                </li>

                {isAuth ? (
                    <>
                        <DrawerItem to="/auth/profile" icon={FiUser}>Profile</DrawerItem>
                        <DrawerItem
                            to="#"
                            icon={FiLogOut}
                            onClick={(e) => {
                                e.preventDefault();
                                handleLogout();
                            }}
                        >
                            Log Out
                        </DrawerItem>
                    </>
                ) : (
                    <>
                        <DrawerItem to="/auth/login" icon={FiLogIn}>Login</DrawerItem>
                        <DrawerItem to="/auth/register" icon={FiUserPlus}>Register</DrawerItem>
                    </>
                )}

                <li>
                    <div className="divider my-2 text-gray-500"></div>
                </li>

                <DrawerItem
                    to="/cart"
                    icon={FiShoppingCart}
                    badge={numCartItems > 0 ? numCartItems : null}
                >
                    Cart
                </DrawerItem>
            </ul>
        </div>
    );
}